import React from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './css/Practice.module.css';

const Writing = () => {
    const navigate = useNavigate()

    const redirectToPage = (page) => {
        navigate(`/${page}`);
    };

    return (
        <main className={styles.page}>
            <header className={styles.pageIntro}>
                <div className={styles.eyebrow}><i className="material-icons">edit_note</i> Writing lab</div>
                <h1>Practice English your way</h1>
                <p>Choose a focused activity, get immediate feedback, and turn every attempt into progress.</p>
            </header>

            <section className={styles.featureGrid} aria-label="Writing activities">
                <button className={`${styles.featureCard} ${styles.featureCardBlue}`}
                        onClick={() => redirectToPage('conversation')} type="button">
                    <div className={styles.featureCardContent}>
                        <span className={styles.featureIcon}><i className="material-icons">forum</i></span>
                        <h2>Free conversation</h2>
                        <p>Write naturally in a guided scenario. Tap unfamiliar words for help and review your own messages.</p>
                        <span className={styles.cardAction}>Start conversation <i className="material-icons">arrow_forward</i></span>
                    </div>
                </button>

                <button className={`${styles.featureCard} ${styles.featureCardGreen}`}
                        onClick={() => redirectToPage('translating')} type="button">
                    <div className={styles.featureCardContent}>
                        <span className={styles.featureIcon}><i className="material-icons">translate</i></span>
                        <h2>Translation practice</h2>
                        <p>Translate short phrases at your pace, compare ideas, and learn from clear feedback after each answer.</p>
                        <span className={styles.cardAction}>Start translating <i className="material-icons">arrow_forward</i></span>
                    </div>
                </button>
            </section>

            <div className="center-align">
                <button className={styles.backLink} onClick={() => navigate('/')} type="button">
                    <i className="material-icons">arrow_back</i> Back to home
                </button>
            </div>
        </main>
    );
};

export default Writing;
